const fontBase = {
  'font-base-default': '16',
};

module.exports = fontBase;
